"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    id: "game-home",
    class: "game-home-container"
};
const _hoisted_2 = { class: "turn-order" };
const _hoisted_3 = { class: "player-name" };
const _hoisted_4 = ["href"];
const _hoisted_5 = {
    key: 0,
    class: "copied-notice"
};
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "player-name" };
const _hoisted_8 = ["href"];
const _hoisted_9 = { key: 0 };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    const _component_purge_warning = (0, vue_1.resolveComponent)("purge-warning");
    const _component_game_setup_detail = (0, vue_1.resolveComponent)("game-setup-detail");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("h1", null, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[1] || (_cache[1] = [
                    (0, vue_1.createTextVNode)("Terraforming Mars", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            _cache[3] || (_cache[3] = (0, vue_1.createTextVNode)(" [", -1)),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[2] || (_cache[2] = [
                    (0, vue_1.createTextVNode)("game id:", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            _cache[4] || (_cache[4] = (0, vue_1.createTextVNode)()),
            (0, vue_1.createElementVNode)("span", null, (0, vue_1.toDisplayString)(_ctx.getGameId()), 1),
            _cache[5] || (_cache[5] = (0, vue_1.createTextVNode)("]", -1))
        ]),
        (0, vue_1.createElementVNode)("h4", null, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[6] || (_cache[6] = [
                    (0, vue_1.createTextVNode)("Instructions: To start the game, separately copy and share the links with all players, and then click on your name.", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            _cache[8] || (_cache[8] = (0, vue_1.createElementVNode)("br", null, null, -1)),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[7] || (_cache[7] = [
                    (0, vue_1.createTextVNode)("Save this page in case you or one of your opponents loses a link.", -1)
                ]))])), [
                [_directive_i18n]
            ])
        ]),
        (0, vue_1.createElementVNode)("ul", null, [
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)((_ctx.game === undefined ? [] : _ctx.game.players), (player, index) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", {
                    key: player.color
                }, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_2, [
                        (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.getTurnOrder(index)), 1)
                    ])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.createElementVNode)("span", {
                        class: (0, vue_1.normalizeClass)('color-square ' + _ctx.getPlayerCubeColorClass(player.color))
                    }, (0, vue_1.toDisplayString)(_ctx.playerSymbol(player.color)), 3),
                    (0, vue_1.createElementVNode)("span", _hoisted_3, [
                        (0, vue_1.createElementVNode)("a", {
                            href: _ctx.getHref(player.id)
                        }, (0, vue_1.toDisplayString)(player.name), 9, _hoisted_4)
                    ]),
                    (0, vue_1.createVNode)(_component_AppButton, {
                        title: "copy",
                        size: "tiny",
                        onClick: ($event) => (_ctx.copyUrl(player.id))
                    }, null, 8, ["onClick"]),
                    (_ctx.isPlayerUrlCopied(player.id))
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_5, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[9] || (_cache[9] = [
                                    (0, vue_1.createTextVNode)("Copied!", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]))
                        : (0, vue_1.createCommentVNode)("", true)
                ]));
            }), 128)),
            (_ctx.game !== undefined && _ctx.game.spectatorId)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", _hoisted_6, [
                    _cache[11] || (_cache[11] = (0, vue_1.createElementVNode)("p", null, null, -1)),
                    _cache[12] || (_cache[12] = (0, vue_1.createElementVNode)("span", { class: "turn-order" }, null, -1)),
                    _cache[13] || (_cache[13] = (0, vue_1.createElementVNode)("span", { class: "color-square" }, null, -1)),
                    (0, vue_1.createElementVNode)("span", _hoisted_7, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                            href: _ctx.getHref(_ctx.game.spectatorId)
                        }, [...(_cache[10] || (_cache[10] = [
                                (0, vue_1.createTextVNode)("Spectator", -1)
                            ]))], 8, _hoisted_8)), [
                            [_directive_i18n]
                        ])
                    ]),
                    (0, vue_1.createVNode)(_component_AppButton, {
                        title: "copy",
                        size: "tiny",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.copyUrl(_ctx.game.spectatorId)))
                    })
                ]))
                : (0, vue_1.createCommentVNode)("", true)
        ]),
        _cache[15] || (_cache[15] = (0, vue_1.createElementVNode)("div", { class: "spacing-setup" }, null, -1)),
        (0, vue_1.createVNode)(_component_purge_warning, {
            expectedPurgeTimeMs: _ctx.game.expectedPurgeTimeMs
        }, null, 8, ["expectedPurgeTimeMs"]),
        _cache[16] || (_cache[16] = (0, vue_1.createElementVNode)("div", { class: "spacing-setup" }, null, -1)),
        (_ctx.game !== undefined)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_9, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h1", null, [...(_cache[14] || (_cache[14] = [
                        (0, vue_1.createTextVNode)("Game settings", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.createVNode)(_component_game_setup_detail, {
                    gameOptions: _ctx.game.gameOptions,
                    playerNumber: _ctx.game.players.length,
                    lastSoloGeneration: _ctx.game.lastSoloGeneration
                }, null, 8, ["gameOptions", "playerNumber", "lastSoloGeneration"])
            ]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
